import React from 'react';
import { useApp } from '../context/AppContext';
import { PRODUCTS } from '../data/catalog';
import GameCard from './GameCard';
import Icon from './Icon';
import './RecentlyViewed.css';

export default function RecentlyViewed() {
  const { recentViews, dispatch } = useApp();
  if (!recentViews || recentViews.length === 0) return null;
  const items = recentViews
    .map((id) => PRODUCTS.find((p) => p.id === id))
    .filter(Boolean)
    .slice(0, 6);
  if (items.length === 0) return null;

  return (
    <section className="section recent">
      <div className="container">
        <div className="section-title">
          <div>
            <div className="eyebrow">上次瀏覽</div>
            <h2>繼續您剛剛在看的</h2>
          </div>
          <button
            className="btn btn-ghost btn-sm"
            onClick={() => dispatch({ type: 'CLEAR_RECENT' })}
          >
            清除紀錄 <Icon name="trash" size={12} />
          </button>
        </div>
        <div className="recent__grid">
          {items.map((p) => (
            <GameCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
